import axios, { AxiosResponse } from "axios";

//#region Routes
export const URL_POST_ERROR = "/Error/Save";
export const URL_POST_ERROR_INTERNAL_INFORMATION = "/Error/SaveInternalInformation";
//#endregion

export const postSaveError = async (error: string): Promise<AxiosResponse> => {
  return await axios.post(URL_POST_ERROR, undefined, { params: { error } });
};

export const postSaveInternalErrorInformation = async (
  referenceNumber: string | null,
  description: string | null,
  image: string | null
): Promise<AxiosResponse> => {
  return await axios.post(URL_POST_ERROR_INTERNAL_INFORMATION, {
    referenceNumber,
    description,
    image,
  });
};
